import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {

    const auth = sessionStorage.getItem("auth");
    const expira = Number(sessionStorage.getItem("expira"));

    if (!auth || Date.now() > expira) {
        sessionStorage.clear();
        return <Navigate to="/ahorrador-login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;